import script from "./MainModalBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MainModalBanner.vue?vue&type=script&setup=true&lang=js"

import "./MainModalBanner.vue?vue&type=style&index=0&id=2a4357c0&lang=scss"

const __exports__ = script;

export default __exports__